import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";

const mapState = (state) => {
	return {
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

const validate = (campos) => {
	const errors = {};

	if(!campos.nombre) {
		errors.nombre = "Campo requerido.";
	} else if (/^\s+/.test(campos.nombre)) {
		errors.nombre = "Campo requerido.";
	}

	if(!campos.email) {
		errors.email = "Campo requerido.";
	}

	if (!campos.email) {
		errors.email = "Campo requerido.";
	} else {
		campos.email =  campos.email.replace(" ","");
		if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(campos.email)) {
			errors.email = "El correo electrónico no es válido. Favor de verificarlo.";
		}
	}

	return errors;
};

const onSubmitFail = (errors,dispatch,submitError,props) => {
	if(errors.email === "Campo requerido." || errors.nombre === "Campo requerido.") {
		dispatch({ "type": "EVENT_ACCESOFAMILIAR_AGREGAR-VACIOS", "dispositivo": props.dispositivo });
	}
	if(errors.email != "Campo requerido."){
		dispatch({ "type": "AF_SET_EVENT", "evento": "DatosIncorrectos-AgregarInvitado", "dispositivo": props.dispositivo});
	}
};

const renderField = ({ input, label, type, cerrar, max, meta: { touched, error, warning } }) => {
	return (
		<div>
			<input {...input} type={type} maxLength={max} />
			{touched && (error &&
				<div className="error-wrap">
					<div className='msj-error'>
						<p><span>{error}</span></p>
					</div>
				</div>)
			}
		</div>
	);
};

class InvitarForm extends React.Component {

	cancel = () => {
		this.props.tagManager({ "type": "EVENT_ACCESOFAMILIAR_AGREGAR-CANCELAR", "dispositivo": this.props.dispositivo });
		this.props.reset();
		$("#modal-invitar").modal("toggle");
	}

	render () {
		const { handleSubmit, pristine, reset, submitting } = this.props;
		return (
			<form onSubmit={handleSubmit}>
				<div>
					<h5><i><img src={ require("../img/icon-invitacion.svg") } /></i>Correo de invitación</h5>
					<hr className="mt-34" />
					<div className="row">
						<div className="col-xs-12 mb-20">
							<div className="texto-17 blue-text">
								<p style={{"textAlign":"justify"}}>Ingresa el nombre y correo electrónico de tu invitado. <br /><br />IMPORTANTE: Si tu invitado ya está registrado en el Portal Soy Cliente o en la Aplicación Soy Cliente GNP, ingresa el correo asociado a su cuenta.</p>
							</div>
							<div className="row">
								<div className="col-xs-12 col-md-10 col-md-offset-1">
									<div className="row">
										<div className="col-xs-12">
											<div className="input-wrap">
												<label>Nombre</label>
												<span className="input-active">
													<Field name="nombre" component={renderField} type="text" max="50" />
												</span>
											</div>
										</div>
										<div className="col-xs-12">
											<div className="input-wrap">
												<label>Correo</label>
												<span className="input-active">
													<Field name="email" component={renderField} type="text" max="50" />
												</span>
											</div>
										</div>
										<div className="col-xs-12">
											<div className="text-center aceptar-cancelar-btn mt-50">
												<a onClick={this.cancel.bind(this)}>Cancelar</a>
												<a onClick={handleSubmit} className="orange-btn">Siguiente</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		);
	}
}

InvitarForm = reduxForm({form: "acceso-familiar-invitar", validate,onSubmitFail})(InvitarForm);

export default connect(mapState, mapDispatch)(InvitarForm);



// WEBPACK FOOTER //
// ./src/acceso-familiar/invitar.frm.js